import { defineMessages } from 'react-intl'

const scope = 'app.components.DashboardInsights'

export default defineMessages({
  titles: {
    nonFiler: {
      id: `${scope}.titles.nonFiler`,
      defaultMessage: 'Non Filer',
    },
    underReport: {
      id: `${scope}.titles.underReport`,
      defaultMessage: 'Under Report',
    },
  },
})
